// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".noResultsMessage--DEn4v{text-align:center;padding:20px;color:#666;font-style:italic}", "",{"version":3,"sources":["webpack://./src/pages/Bundles/components/History/history-search.module.scss"],"names":[],"mappings":"AAAA,yBACE,iBAAA,CACA,YAAA,CACA,UAAA,CACA,iBAAA","sourcesContent":[".noResultsMessage {\n  text-align: center;\n  padding: 20px;\n  color: #666;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noResultsMessage": "noResultsMessage--DEn4v"
};
export default ___CSS_LOADER_EXPORT___;
